import { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import moment from "moment";
import { postAxios } from "../../util/postAxios";
import { monthDefaultFormat, dayDefault } from "../../util/formatDate";

export const useDashboard = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;
  const getTim = localStorage.getItem("user");
  const jsonTim = JSON.parse(getTim);

  const filterDateYear = new Date();
  const filter = filterDateYear.getFullYear();

  const [dataUser, setDataUser] = useState();
  const [dataUserEdit, setDataUserEdit] = useState();
  const [paramSearch, setParamSearch] = useState("name");
  const [valueSearch, setValueSearch] = useState("");
  const [isEditAbsen, setIsEditAbsen] = useState(false);
  const [isEditOverTime, setIsEditOverTime] = useState(false);
  const [initialEdit, setInitialEdit] = useState(false);
  const [initialEditOT, setInitialEditOT] = useState(false);
  const [clockInValueEdit, setClockInValueEdit] = useState("");
  const [clockOutValueEdit, setClockOutValueEdit] = useState("");
  const [statusCode, setStatusCode] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState(filter);
  const [filterRole, setFilterRole] = useState("");
  const [filterKepala, setFilterKepala] = useState("");
  const [dateClockOut, setDateClockOut] = useState(new Date());
  const [dateClockIn, setDateClockIn] = useState(new Date());
  const [filterDate, setFilterDate] = useState("");
  const [clockIn, setClockIn] = useState("");
  const [dateIn, setDateIn] = useState("");
  const [clockOut, setClockOut] = useState("");
  const [dateOut, setDateOut] = useState("");
  const [ktpNumber, setKtpNumber] = useState("");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateUntil, setFilterDateUntil] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [popUp, setPopUp] = useState(true);

  const [file, setFile] = useState(null);
  const [fileImportJam, setFileImportJam] = useState(null);
  const [isReload, setIsReload] = useState(false);
  const [popUpImport, setPopUpImport] = useState(false);
  const [dateHariLibur, setDateHariLibur] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );
  const [listOperator, setListOperator] = useState();
  const [dataHariLibur, setDataHariLibur] = useState();
  const [subMenuAbsensi, setSubMenuAbsensi] = useState("Absensi");
  const [operatorPick, setOperatorPick] = useState();

  const [filterMonthTable, setFilterMonthTable] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterYearTable, setFilterYearTable] = useState(
    moment().utcOffset("+0700").year()
  );
  const [dataTableLibur, setDataTableLibur] = useState();

  const [filterShift, setFilterShift] = useState("Pilih Shift");

  const [valueSearchTable, setValueSearchTable] = useState("");

  const [filterFrom, setFilterFrom] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );
  const [filterUntil, setFilterUntil] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );
  const [popUpFilterTable, setPopUpFilterTable] = useState(false);

  const [isFilterRange, setIsFilterRange] = useState(false);

  const [dataFilterRange, setDataFilterRange] = useState();

  const getDefaultDate = new Date(filterDate);
  let defaultDay = getDefaultDate.getDay();
  let defaultMonth = getDefaultDate.getMonth();
  let defaultDateNumber = getDefaultDate.getDate();
  let year = getDefaultDate.getFullYear();
  const defaultDate = `${dayDefault[defaultDay]} ${monthDefaultFormat[defaultMonth]} ${defaultDateNumber} ${year}`;

  let editParams = [];
  let editOTParams = [];

  const sortByShift = (data) =>
    data.sort(function (a, b) {
      if (a.shift < b.shift) {
        return -1;
      }
      if (a.shift > b.shift) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  const sortByName = (data) =>
    data.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

  const getTableData = async () => {
    try {
      if (filterMonth !== "") {
        const response = await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/userList`,
          {
            filterMonth: filterMonth,
            filterYear: filterYear,
            filterRole: filterRole,
            kepalaShift: filterKepala,
            type: "absent",
            filterDate: filterDate === "" ? "" : defaultDate,
            tim: jsonTim.tim,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
        if (response.data.code === 404) {
          setStatusCode(
            response.data.code !== undefined ? response.data.code : ""
          );
        } else {
          setDataUser(sortByName(response.data));
        }
      }
    } catch (error) {
      return error;
    }
  };

  const handleFilterUntil = async () => {
    try {
      if (filterMonth !== "") {
        const response = await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/userList`,
          {
            filterDateFrom: filterDateFrom,
            filterDateUntil: filterDateUntil,
            type: "filterUntil",
            tim: jsonTim.tim,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
        if (response.data.code === 404) {
          setStatusCode(
            response.data.code !== undefined ? response.data.code : ""
          );
        } else {
          setDataUser(sortByName(response.data));
          setIsFilter(false);
        }
      }
    } catch (error) {
      return error;
    }
  };

  const handleExportRange = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/exportExcel`,
        {
          filterDateFrom: filterDateFrom,
          filterDateUntil: filterDateUntil,
          type: "range",
          tim: jsonTim.tim,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );

      const d = new Date();
      const year = d.getFullYear();

      const sortByNama = response.data.sort(function (a, b) {
        if (a.Nama < b.Nama) {
          return -1;
        }
        if (a.Nama > b.Nama) {
          return 1;
        }
        return 0;
      });

      const filteredData =
        sortByNama &&
        sortByNama.map((obj, index) => {
          const a = new Date(`${obj.ClockIn} ${obj.ClockInTime}:00 GMT+0700`);
          const b = new Date(`${obj.ClockOut} ${obj.ClockOutTime}:00 GMT+0700`);
          let hours = Math.abs(b - a) / 36e5;
          let rhours = Math.floor(hours);
          let minutes = (hours - rhours) * 60;
          let rminutes = Math.round(minutes);
          let totalSecond = rhours * 3600 + rminutes * 60;

          const validateTotalWorking = () => {
            if (totalSecond >= 25200) {
              return 25200;
            } else {
              return totalSecond;
            }
          };

          return {
            No: index + 1,
            id: obj.ID,
            Name: obj.Nama,
            Bagian: obj.Bagian,
            ClockIn: obj.ClockIn,
            "ClockIn Time": obj.ClockInTime,
            ClockOut: obj.ClockOut,
            "ClockOut Time": obj.ClockOutTime,
            "Jumlah Jam": validateTotalWorking() / 3600,
          };
        });

      const workSheet = XLSX.utils.json_to_sheet(filteredData && filteredData);
      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 18 },
        { wch: 47 },
        { wch: 19 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "attendance");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, `absensi Range ${year}.xlsx`);
    } catch (error) {
      return error;
    }
    setIsFilter(false);
  };

  const updateUser = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/updateUser`,
        data,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      return error;
    }
  };

  const addNewAbsent = () => {
    const addNewDateIn = new Date(dateIn);
    let dayIn = addNewDateIn.getDay();
    let monthIn = addNewDateIn.getMonth();
    let date = addNewDateIn.getDate();
    let yearIn = addNewDateIn.getFullYear();
    const dateClockIn = `${dayDefault[dayIn]} ${monthDefaultFormat[monthIn]} ${date} ${yearIn}`;
    const addNewDateOut = new Date(dateOut);
    let dayOut = addNewDateOut.getDay();
    let monthOut = addNewDateOut.getMonth();
    let dateAddNewOut = addNewDateOut.getDate();
    let yearOut = addNewDateOut.getFullYear();
    const dateClockOut = `${dayDefault[dayOut]} ${monthDefaultFormat[monthOut]} ${dateAddNewOut} ${yearOut}`;
    updateUser({
      id: ktpNumber,
      type: "addNewAbsent",
      tanggalMasuk: dateClockIn,
      jamMasuk: clockIn,
      tanggalKeluar: dateClockOut,
      jamKeluar: clockOut,
    });
    setClockIn("");
    setDateIn("");
    setClockOut("");
    setDateOut("");
  };

  const searchFeature = (params) => {
    if (paramSearch === "name" && valueSearch !== "") {
      let searchName = [];
      dataUser &&
        dataUser.forEach((value) => {
          if (value.name.toLowerCase().includes(params.toLowerCase())) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return dataUser;
    }
  };

  const handleEdit = (index, type) => {
    if (type === "absent") {
      setIsEditAbsen(true);
      if ((editParams[index] = !editParams[index])) {
        setInitialEdit([...editParams]);
      }
    } else if (type === "overTime") {
      setIsEditOverTime(true);
      if ((editOTParams[index] = !editOTParams[index])) {
        setInitialEditOT([...editOTParams]);
      }
    }
  };

  const handleFormatDateEdit = (data) => {
    const getDefaultDate = new Date(data);
    let defaultDay = getDefaultDate.getDay();
    let defaultMonth = getDefaultDate.getMonth();
    let defaultDateNumber = getDefaultDate.getDate();
    let year = getDefaultDate.getFullYear();
    return `${dayDefault[defaultDay]} ${monthDefaultFormat[defaultMonth]} ${defaultDateNumber} ${year}`;
  };

  const handleKirim = (data, id, type) => {
    const obj = {
      id: id,
      type: type,
      dataEdit: data.clockIn.day,
      absent: {
        clockIn: {
          day: handleFormatDateEdit(dateClockIn),
          time: `${clockInValueEdit}:00`,
        },
        clockOut: {
          day: handleFormatDateEdit(dateClockOut),
          time: `${clockOutValueEdit}:00`,
        },
      },
    };
    if (clockInValueEdit !== "" && clockOutValueEdit !== "") {
      updateUser(obj);
    }
    setClockInValueEdit("");
    setClockOutValueEdit("");
    setIsEditAbsen(false);
    setIsEditOverTime(false);
  };

  const handleExportExcel = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/exportExcel`,
        {
          filterMonth: filterMonth,
          filterRole: filterRole,
          filterYear: filterYear,
          type: "absent",
          tim: jsonTim.tim,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      const d = new Date();
      const year = d.getFullYear();

      const sortByNama = response.data.sort(function (a, b) {
        if (a.Nama < b.Nama) {
          return -1;
        }
        if (a.Nama > b.Nama) {
          return 1;
        }
        return 0;
      });

      const workSheet = XLSX.utils.json_to_sheet(sortByNama);
      workSheet["!cols"] = [
        { wch: 17 },
        { wch: 32 },
        { wch: 16 },
        { wch: 22 },
        { wch: 22 },
        { wch: 5 },
        { wch: 15 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "attendance");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, `absensi ${filterMonth} ${year}.xlsx`);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    getTableData();
  }, [filterMonth, filterRole, filterDate, filterYear, filterKepala]);

  const handleExportJamLebih = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/exportExcel`,
        {
          filterDateFrom: filterDateFrom,
          filterDateUntil: filterDateUntil,
          type: "jamLebih",
          tim: jsonTim.tim,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );

      const d = new Date();
      const year = d.getFullYear();

      const sortByNama = response.data.sort(function (a, b) {
        if (a.Nama < b.Nama) {
          return -1;
        }
        if (a.Nama > b.Nama) {
          return 1;
        }
        return 0;
      });

      const filteredData =
        sortByNama &&
        sortByNama.map((obj, index) => {
          const a = new Date(`${obj.tanggalMasuk} ${obj.jamMasuk}:00 GMT+0700`);
          const b = new Date(
            `${obj.tanggalKeluar} ${obj.jamKeluar}:00 GMT+0700`
          );
          let hours = Math.abs(b - a) / 36e5;
          let rhours = Math.floor(hours);
          let minutes = (hours - rhours) * 60;
          let rminutes = Math.round(minutes);
          let totalSecond = rhours * 3600 + rminutes * 60;

          const validateTotalWorking = () => {
            if (totalSecond >= 25200) {
              return 25200;
            } else {
              return totalSecond;
            }
          };

          return {
            No: index + 1,
            id: obj.ID,
            Name: obj.Nama,
            tanggalMasuk: obj.tanggalMasuk,
            jamMasuk: obj.jamMasuk,
            tanggalKeluar: obj.tanggalKeluar,
            jamKeluar: obj.jamKeluar,
            "Jumlah Jam": validateTotalWorking() / 3600,
          };
        });

      const workSheet = XLSX.utils.json_to_sheet(filteredData && filteredData);
      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 18 },
        { wch: 32 },
        { wch: 15 },
        { wch: 9 },
        { wch: 15 },
        { wch: 9 },
        { wch: 10 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "attendance");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, `Ambil Jam Lebih Range ${year}.xlsx`);
    } catch (error) {
      return error;
    }
    setIsFilter(false);
  };

  const getTableListOrang = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/getListHariLibur`,
        {
          tgl: moment(dateHariLibur).utcOffset("+0700").format("DD/MM/YY"),
          tim: jsonTim.tim,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      if (response.data.code === 404) {
        setStatusCode(
          response.data.code !== undefined ? response.data.code : ""
        );
      } else {
        setDataHariLibur(sortByShift(response.data.data));
      }
    } catch (error) {
      return error;
    }
  };

  const getDataUserEdit = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/userList`,
        { type: "editUser", tim: jsonTim.tim },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      if (response.data.code === 404) {
        setStatusCode(
          response.data.code !== undefined ? response.data.code : ""
        );
      } else {
        setDataUserEdit(response.data);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    if (subMenuAbsensi === "HariLibur") {
      getDataUserEdit();
      getTableListOrang();

      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/formLembur`,
        { tim: jsonTim.tim, type: "getUser" },
        getToken,
        setListOperator,
        ""
      );

      setIsReload(false);
    }
    if (subMenuAbsensi === "TabelLibur") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getTableLibur`,
        {
          tim: jsonTim.tim,
          type: "noRange",
          filterMonth: `${filterYearTable}/${("0" + filterMonthTable).slice(
            -2
          )}`,
        },
        getToken,
        setDataTableLibur,
        ""
      );

      setIsReload(false);
    }
  }, [
    isReload,
    dateHariLibur,
    subMenuAbsensi,
    filterYearTable,
    filterMonthTable,
  ]);

  const handleImportHariLibur = () => {
    if (file) {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/importHariLibur`,
          { data: json, tim: jsonTim.tim },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
      };
      reader.readAsBinaryString(file);
      setPopUpImport(true);
      setIsReload(true);
      setFile(null);
    }
  };

  const handleDeleteOrang = async (data) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/deleteOrangLibur`,
        { formId: data },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      setIsReload(true);
    } catch (error) {
      return error;
    }
  };

  const handleImportJam = () => {
    if (fileImportJam) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/importJam`,
          {
            data: json,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
      };
      reader.readAsBinaryString(fileImportJam);
    }
  };

  let reFormat = [];
  listOperator &&
    listOperator.forEach((element) => {
      reFormat.push({ value: element.id, label: element.name });
    });

  const handleKirimSatuan = () => {
    if (operatorPick) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/inputLiburSatuan`,
        {
          tim: jsonTim.tim,
          date: moment(dateHariLibur).utcOffset("+0700").format(),
          id: operatorPick.value,
        },

        getToken,
        "",
        ""
      );

      setOperatorPick();
      setIsReload(true);
    }
  };

  let dateTempListTanggal = [];

  var days = moment(
    `${filterYearTable}/${("0" + filterMonthTable).slice(-2)}`
  ).daysInMonth();

  for (let index = 0; index < days; index++) {
    dateTempListTanggal.push({
      date: `${filterYearTable}/${("0" + filterMonthTable).slice(-2)}/${(
        "0" +
        (index + 1)
      ).slice(-2)}`,
      tanggal: `${("0" + (index + 1)).slice(-2)}`,
    });
  }

  const findSamePerson =
    dataTableLibur &&
    dataTableLibur.reduce((obj, item) => {
      let find = obj.find((i) => i.id === item.id);
      let _d = {
        ...item,
      };

      if (find) {
        find.listTgl = [
          ...find.listTgl,
          {
            date: item.tgl,
            tanggal: moment(item.tgl).utcOffset("+0700").format("DD"),
            status: item.status,
            color: item.color,
          },
        ];
      } else {
        obj.push({
          listTgl: [
            {
              date: _d.tgl,
              tanggal: moment(_d.tgl).utcOffset("+0700").date(),
              status: _d.status,
              color: _d.color,
            },
          ],
          bagian: _d.bagian,
          filterMonth: _d.filterMonth,
          formId: _d.formId,
          id: _d.id,
          name: _d.name,
          shift: _d.shift,
          tgl: _d.tgl,
          tim: _d.tim,
        });
      }
      return obj;
    }, []);

  const findSameShift =
    findSamePerson &&
    findSamePerson.reduce((acc, currentItem) => {
      if (!acc.some((item) => item.shift === currentItem.shift)) {
        acc.push(currentItem);
      }
      return acc;
    }, []);

  const multipleSort =
    findSamePerson &&
    findSamePerson.sort((a, b) => {
      if (a.shift < b.shift) return -1;
      if (a.shift > b.shift) return 1;

      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      return 0;
    });

  const findSamePersonRange =
    dataFilterRange &&
    dataFilterRange.reduce((obj, item) => {
      let find = obj.find((i) => i.id === item.id);
      let _d = {
        ...item,
      };

      if (find) {
        find.listTgl = [
          ...find.listTgl,
          {
            date: item.tgl,
            tanggal: moment(item.tgl).utcOffset("+0700").format("DD"),
            status: item.status,
            color: item.color,
          },
        ];
      } else {
        obj.push({
          listTgl: [
            {
              date: _d.tgl,
              tanggal: moment(_d.tgl).utcOffset("+0700").date(),
              status: _d.status,
              color: _d.color,
            },
          ],
          bagian: _d.bagian,
          filterMonth: _d.filterMonth,
          formId: _d.formId,
          id: _d.id,
          name: _d.name,
          shift: _d.shift,
          tgl: _d.tgl,
          tim: _d.tim,
        });
      }
      return obj;
    }, []);

  const dateTempListTanggalRange = [];

  dataFilterRange &&
    dataFilterRange.forEach((element) => {
      const foundObject = dateTempListTanggalRange.find(
        (obj) => obj.date === element.tgl
      );
      if (!foundObject) {
        dateTempListTanggalRange.push({
          date: element.tgl,
          tanggal: moment(element.tgl).utcOffset("+0700").format("DD"),
        });
      }
    });

  const handleResetFilterTable = () => {
    setFilterYearTable(moment().utcOffset("+0700").year());
    setFilterMonthTable(moment().utcOffset("+0700").month() + 1);
    setFilterShift("Pilih Shift");
    setValueSearchTable("");
    setFilterFrom(moment().utcOffset("+0700").format("YYYY-MM-DD"));
    setFilterUntil(moment().utcOffset("+0700").format("YYYY-MM-DD"));
    setIsReload(true);
    setIsFilterRange(false);
  };

  const searchFeatureTableLibur = (params) => {
    const keyword = (params || "").toLowerCase();

    return (
      multipleSort?.filter((item) => {
        const matchName =
          keyword === "" || (item.name || "").toLowerCase().includes(keyword);

        const matchShift =
          filterShift === "Pilih Shift" || item.shift === filterShift;

        return matchName && matchShift;
      }) || []
    );
  };
  let dataTempPoSearch = searchFeatureTableLibur(valueSearchTable);

  const searchFeatureTableRange = (params) => {
    const keyword = String(params || "").toLowerCase();

    return (findSamePersonRange || []).filter((value) => {
      const matchName =
        keyword === "" ||
        String(value.name || "")
          .toLowerCase()
          .includes(keyword);

      const matchShift =
        filterShift === "Pilih Shift" || value.shift === filterShift;

      return matchName && matchShift;
    });
  };
  let dataTempPoSearchRange = searchFeatureTableRange(valueSearchTable);

  const filterRange = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getTableLibur`,
      {
        tim: jsonTim.tim,
        type: "range",
        from: filterFrom,
        until: filterUntil,
      },
      getToken,
      setDataFilterRange,
      ""
    );

    setPopUpFilterTable(false);
    setIsFilterRange(true);
  };

  const handleDeleteAbsent = (data, id) =>
    updateUser({
      id,
      type: "deleteAbsent",
      day: data.clockIn.day,
      time: data.clockIn.time,
    });
  return {
    dataUser,
    jsonTim,
    valueSearch,
    setValueSearch,
    setParamSearch,
    searchFeature,
    handleEdit,
    isEditAbsen,
    setIsEditAbsen,
    initialEdit,
    setInitialEdit,
    initialEditOT,
    editParams,
    handleKirim,
    setClockInValueEdit,
    setClockOutValueEdit,
    statusCode,
    setFilterMonth,
    filterMonth,
    setFilterRole,
    handleExportExcel,
    editOTParams,
    isEditOverTime,
    setDateClockOut,
    dateClockOut,
    setFilterDate,
    addNewAbsent,
    setClockIn,
    setDateIn,
    setClockOut,
    setDateOut,
    setKtpNumber,
    setDateClockIn,
    dateClockIn,
    isFilter,
    setIsFilter,
    setFilterDateFrom,
    setFilterDateUntil,
    handleFilterUntil,
    setFilterYear,
    filterYear,
    filterKepala,
    setFilterKepala,
    handleExportRange,
    popUp,
    setPopUp,
    handleExportJamLebih,
    setFile,
    handleImportHariLibur,
    popUpImport,
    setPopUpImport,
    dateHariLibur,
    setDateHariLibur,
    subMenuAbsensi,
    setSubMenuAbsensi,
    dataHariLibur,
    handleDeleteOrang,
    dataUserEdit,
    setFileImportJam,
    handleImportJam,
    reFormat,
    operatorPick,
    setOperatorPick,
    handleKirimSatuan,
    dateTempListTanggal,
    findSameShift,
    filterShift,
    setFilterShift,
    handleResetFilterTable,
    valueSearchTable,
    setValueSearchTable,
    dataTempPoSearch,
    filterMonthTable,
    setFilterMonthTable,
    filterYearTable,
    setFilterYearTable,
    popUpFilterTable,
    setPopUpFilterTable,
    filterRange,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    findSamePersonRange,
    isFilterRange,
    dateTempListTanggalRange,
    dataTempPoSearchRange,
    clockInValueEdit,
    clockOutValueEdit,
    handleDeleteAbsent,
    setIsEditOverTime,
    setInitialEditOT,
  };
};
